import { ScrollReveal } from "@components/motion/Transitioned"
import { ContentBlock } from "eddev/blocks"

const HTMLHeading = (props: ContentBlock) => {
  if (typeof props.innerHTML === "string") {
    return <div dangerouslySetInnerHTML={{ __html: props.innerHTML }} className="block-heading" />
  } else {
    return null
  }
}

const HTMLParagraph = (props: ContentBlock) => {
  if (typeof props.innerHTML === "string") {
    return <div dangerouslySetInnerHTML={{ __html: props.innerHTML }} className="block-p" />
  } else {
    return null
  }
}

const HTMLList = (props: ContentBlock) => {
  if (typeof props.innerHTML === "string") {
    return <div dangerouslySetInnerHTML={{ __html: props.innerHTML }} className="block-list" />
  } else {
    return null
  }
}

export default {
  "core/rich-text": (props: ContentBlock) => {
    return <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: props.innerHTML! }}></div>
  },
  "core/heading": HTMLHeading,
  "core/paragraph": HTMLParagraph,
  "core/list": HTMLList,

  "group/wysiwyg": (props: ContentBlock) => {
    return (
      // <ScrollReveal>
      <div
        className="max-w-grid mx-auto rich-text-group"
        // data-transition="children/fade"
        dangerouslySetInnerHTML={{ __html: props.innerHTML as string }}
      />
      // </ScrollReveal>
    )
  },
}
